'use client'

import * as AccordionPrimitive from '@radix-ui/react-accordion'
import { type ComponentProps } from 'react'

import { cn } from '@/shared/lib'
import { Icon } from '@/shared/ui'

export const Root = ({
  className,
  children,
  ...props
}: ComponentProps<typeof AccordionPrimitive.Item>) => {
  return (
    <AccordionPrimitive.Root type="single" collapsible data-slot="accordion">
      <AccordionPrimitive.Item
        data-slot="accordion-item"
        className={className}
        {...props}
      >
        {children}
      </AccordionPrimitive.Item>
    </AccordionPrimitive.Root>
  )
}

export const Trigger = ({
  className,
  children,
  ...props
}: ComponentProps<typeof AccordionPrimitive.Trigger>) => {
  return (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        data-slot="accordion-trigger"
        className={cn(
          'typo-body1-reading flex flex-1 cursor-pointer items-start justify-between gap-4 rounded-sm font-semibold text-black transition-all outline-none',
          'focus-visible:ring-ring focus-visible:ring-2',
          '[&[data-state=open]>svg]:rotate-180',
          className,
        )}
        {...props}
      >
        {children}
        <Icon
          name="arrow-bottom"
          size={24}
          strokeWidth={1.5}
          className="pointer-events-none shrink-0 translate-y-0.5 text-black transition-transform duration-200"
        />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  )
}

export const Content = ({
  className,
  children,
  ...props
}: ComponentProps<typeof AccordionPrimitive.Content>) => {
  return (
    <AccordionPrimitive.Content
      data-slot="accordion-content"
      className="data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden"
      {...props}
    >
      <div className={className}>{children}</div>
    </AccordionPrimitive.Content>
  )
}
